import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"
import PropTypes from "prop-types"

const PopupModal = ({
  isOpen,
  toggle,
  title,
  children,
  size = "lg",
  centered = true,
  showFooter = true,
  footerButtons = null,
  className = "",
  headerClassName = "",
  bodyClassName = "",
  footerClassName = "",
}) => {
  const defaultFooterButtons = (
    <Button type="button" color="secondary" onClick={toggle}>
      Close
    </Button>
  )

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size={size}
      className={centered ? "modal-dialog-centered" : ""}
    >
      <ModalHeader toggle={toggle} className={headerClassName}>
        <h4 className="modal-title">{title}</h4>
      </ModalHeader>
      <ModalBody className={bodyClassName}>
        {children}
      </ModalBody>
      {showFooter && (
        <ModalFooter className={footerClassName}>
          {footerButtons || defaultFooterButtons}
        </ModalFooter>
      )}
    </Modal>
  )
}

PopupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["sm", "lg", "xl"]),
  centered: PropTypes.bool,
  showFooter: PropTypes.bool,
  footerButtons: PropTypes.node,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  footerClassName: PropTypes.string,
}

export default PopupModal